<template>
    <div class="page_content">
        <h1 class="head_title">学位申请</h1>
        <div v-if="isFirstTime" class="first-time-content">
            <!-- <p>您是第一次进入学位申请页面，请确认是否需要进行学位申请：</p> -->
            <p>欢迎来到学位申请页面，请确认是否需要进行学位申请：</p>
            <el-button type="primary" @click="confirmDegreeApply(true)">是，我要申请学位</el-button>
            <el-button @click="confirmDegreeApply(false)">否，暂不申请</el-button>
        </div>
        <div v-else class="application-content">
            <p>您已经选择了学位申请服务，这里是学位申请的具体内容。</p>
            <!-- 这里可以添加具体的学位申请表单 -->
            <el-form ref="degreeApplyForm" :model="form" :rules="rules" label-width="140px" >
                <el-form-item label="外语水平认定" prop="optionKey">
                    <el-select v-model="form.optionKey" placeholder="请选择" style="width: 100%;" :disabled="isReadOnly && auditStatus != 3" :loading="loadingOptions" @change="handleOptionChange">
                        <el-option
                            v-for="item in languageOptions"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户名" prop="userName" v-if="currentOptionConfig.showUserNameInput">
                    <el-input v-model="form.userName" style="width: 500px;" auto-complete="new-password" :disabled="isReadOnly && auditStatus != 3" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" v-if="currentOptionConfig.showPasswordInput">
                    <el-input v-model="form.password" style="width: 500px;" auto-complete="new-password" :disabled="isReadOnly && auditStatus != 3" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="上传学位英语材料" :required="currentOptionConfig.attachmentRequired && currentOptionConfig.showAttachmentInput" prop="approveFileUrls" v-if="currentOptionConfig.showAttachmentInput" style="width: 640px;">
                    <el-upload
                        v-if="auditStatus != 3"
                        class="upload-demo"
                        :action="uploadUrl"
                        :disabled="isReadOnly"
                        :headers="headers"
                        :on-success="handleUploadSuccess"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                        multiple>
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">支持多文件上传</div> -->
                    </el-upload>
                    <el-upload
                        v-if="auditStatus == 3"
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="headers"
                        :on-success="handleUploadSuccess"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                        multiple>
                        <el-button size="small" type="primary">重新上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">支持多文件上传</div> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="申请表" required prop="attributeRelationList" v-if="degreeApplyInfo.templateId">
                    <el-button type="primary" size="small" @click="openFillDataDialog" >{{isReadOnly?"查看申请表":'立即填写'}}</el-button>
                </el-form-item>
                <!-- 审核状态和备注信息 -->
                <el-form-item v-if="auditStatus || auditRemark">
                    <div class="audit-info">
                        <div v-if="auditStatus" class="audit-status" :class="getStatusClass(auditStatus)">
                            <span class="label">审核状态：</span>
                            <span class="value">{{ getAuditStatusText(auditStatus) }}</span>
                        </div>
                        <div v-if="auditRemark" class="audit-remark">
                            <span class="label">审核备注：</span>
                            <span class="value">{{ auditRemark }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-if="!isReadOnly || auditStatus == 3">
                    <el-button type="primary" @click="submitApplication" :disabled="isReadOnly && auditStatus != 3">{{isReadOnly?"重新提交":'提交申请'}}</el-button>
                    <el-button @click="cancelApplication" :disabled="isReadOnly && auditStatus != 3">取消</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 填写数据对话框 -->
        <degreeTemplateEdit
            v-if="fillDataDialogVisible && degreeApplyInfo.templateId"
            ref="childComponent"
            :toolShow="true"
            @onClosedialog="fillDataDialogVisible = false;"
            :dialogShow="fillDataDialogVisible"
            :showInfo="{
                edit: true,
                print: false,
                down: false,
                save: true
            }">
        </degreeTemplateEdit>
    </div>
</template>

<script>
    import { getStorageKeyForRoleTag,getCookieForRoleTag } from '../common/ulit';
    import degreeTemplateEdit from '../components/degreeTemplateEdit.vue';
    export default {
        name: "DegreeApplication",
        components: {
            degreeTemplateEdit
        },
        data() {
            return {
                isFirstTime: false,
                uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
                headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
                fileList: [], // 上传文件列表
                degreeApplyInfo: { // 学位申请说明信息
                    info: '',
                    fileUrls: '',
                    fileUrlList: [],
                    templateId: '',
                    linkTemplateName: ''
                },
                loadingTemplate: false, // 是否正在加载模板信息
                languageOptions: [], // 语言选项列表
                loadingOptions: false, // 是否正在加载选项
                isReadOnly: false, // 是否只读模式
                auditStatus: null, // 审核状态
                auditRemark: '', // 审核备注
                currentOptionConfig: { // 当前选中的外语水平认定配置
                    showUserNameInput: true,
                    showPasswordInput: true,
                    userNameRequired: true,
                    passwordRequired: true,
                    showAttachmentInput: true,
                    attachmentRequired: true
                },
                rules: {
                    optionKey: [{
                        required: true,
                        message: '请选择下拉框',
                        trigger: 'change'
                    }],
                    userName: [{
                        required: false, // 动态设置，初始为非必填
                        message: '请填写用户名',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: false, // 动态设置，初始为非必填
                        message: '请填写密码',
                        trigger: 'blur'
                    }],
                    approveFileUrls: [{
                        validator: (rule, value, callback) => {
                            // 检查是否需要验证附件
                            if (this.currentOptionConfig.showAttachmentInput && this.currentOptionConfig.attachmentRequired) {
                                if (!value || value.trim() === '') {
                                    callback(new Error('请上传必要的附件'));
                                } else {
                                    callback();
                                }
                            } else {
                                // 如果不需要附件，则验证通过
                                callback();
                            }
                        },
                        trigger: 'blur' // 或者 'change'，取决于何时触发验证
                    }],
                    attributeRelationList: [{
                        validator: (rule, value, callback) => {
                            // 检查是否有模板ID，如果有则需要验证是否填写了模板
                            if (this.degreeApplyInfo.templateId) {
                                // 检查attributeRelationList是否为空或者长度为0
                                if (!value || !Array.isArray(value) || value.length === 0) {
                                    callback(new Error('请填写申请表'));
                                } else {
                                    callback();
                                }
                            } else {
                                // 如果没有模板ID，则不需要验证
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }]
                },
                form: {
                    degreeApplyRecordId:"",
                    optionKey: "",
                    userName: "",
                    password: "",
                    approveFileUrls: '', // 附件路径，逗号分隔
                    attributeRelationList: [] // 模板填写的属性列表
                },
                fillDataDialogVisible: false // 填写数据对话框显示状态
            };
        },
        created() {

        },
        mounted() {
            this.checkDegreeApplyConfig();
        },
        methods: {
            // 检查学位申请配置
            checkDegreeApplyConfig() {
                this.$store.dispatch("user/getDegreeApplyConfig").then((ret) => {
                    if (ret.code === 0) {
                        if (ret.data === null || ret.data.showFlag == 2) {
                            // 第一次进入，显示选择框
                            this.isFirstTime = true;
                        } else if(ret.data.showFlag == 1){
                            // 已有配置，正常显示申请页面
                            this.isFirstTime = false;

                            this.loadDegreeTemplateInfo(); // 加载学位申请模板信息
                            this.degreeApplyForLanguageOption(); // 获取学位申请配置选项
                        }
                    } else {
                        this.$message.error('获取学位申请配置失败');
                    }
                }).catch((err) => {
                    this.$message.error('获取学位申请配置失败');
                });
            },

            // 确认是否进行学位申请
            confirmDegreeApply(apply) {
                const showFlag = apply ? 1 : 2; // 1是，我要申请学位 2否，暂不申请
                this.$store.dispatch("user/addDegreeApplyConfig",{showFlag:showFlag}).then((ret) => {
                    if (ret.code === 0) {
                        if(showFlag == 1){
                            this.isFirstTime = false;
                            // this.loadStudentInfo();
                            this.$message.success('已确认进行学位申请');
                            this.degreeApplyForLanguageOption(); // 获取学位申请配置选项
                            this.loadDegreeTemplateInfo();
                        }else{
                            this.cancelApplication();
                        }
                    } else {
                        this.$message.error('保存配置失败');
                    }
                }).catch((err) => {
                    this.$message.error('获取学位申请配置失败');
                });
            },

            // 加载学生信息
            loadStudentInfo() {
                // 这里应该从全局状态或API获取学生信息
                const studentInfo = this.$store.state.user.studentInfo || {};
                this.form.name = studentInfo.studentName || '';
                this.form.studentId = studentInfo.studentId || '';
                this.form.major = studentInfo.major || '';
            },

            // 提交申请
            submitApplication() {
                // 获取模板填写的数据
                const cachedDataStr = sessionStorage.getItem(getStorageKeyForRoleTag('template_' + this.degreeApplyInfo.templateId));
                if(cachedDataStr) {
                    this.form.attributeRelationList = JSON.parse(cachedDataStr).attributeRelationList;
                }

                this.$refs.degreeApplyForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确定提交，提交后将无法进行修改?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });

                            // 创建提交数据副本，根据配置过滤不显示的字段
                            const submitData = { ...this.form };

                            // 如果用户名输入框不显示，移除userName字段
                            if (!this.currentOptionConfig.showUserNameInput) {
                                delete submitData.userName;
                            }

                            // 如果密码输入框不显示，移除password字段
                            if (!this.currentOptionConfig.showPasswordInput) {
                                delete submitData.password;
                            }

                            // 如果附件上传不显示，移除approveFileUrls字段
                            if (!this.currentOptionConfig.showAttachmentInput) {
                                delete submitData.approveFileUrls;
                            }

                            this.$store.dispatch("user/submitDegreeApplyRecord", submitData).then(response => {
                                loading.close();
                                if (response.code === 0) {
                                    this.$message.success('学位申请提交成功');
                                    // this.$router.go(-1); // 返回上一页
                                    this.getLatestDegreeApplyRecord();
                                } else {
                                    this.$message.error('提交失败：' + response.msg);
                                }
                            }).catch(error => {
                                loading.close();
                                console.error('提交学位申请错误:', error);
                                this.$message.error('提交失败');
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '取消提交'
                            });
                        });
                    } else {
                        this.$message.error('请填写完整信息');
                    }
                });
            },

            // 文件上传成功
            handleUploadSuccess(res, file) { // 文件上传成功
                if (res.code === 0 || res.code === '0') {
                    const fileUrl = res.data.url;
                    const fileName = res.data.nameFormat || file.name;
                    // 将文件URL添加到列表中
                    if (!this.form.approveFileUrls) {
                        this.form.approveFileUrls = fileUrl;
                    } else {
                        this.form.approveFileUrls += ',' + fileUrl;
                    }
                    // 更新文件列表显示
                    if (!this.fileList) {
                        this.fileList = [];
                    }
                    this.fileList.push({
                        name: fileName,
                        url: fileUrl,
                        response: res
                    });
                    this.$message.success('文件上传成功');

                    // 清除表单验证错误提示
                    if (this.$refs.degreeApplyForm) {
                        this.$refs.degreeApplyForm.clearValidate('approveFileUrls');
                    }
                } else {
                    this.$message.error(res.msg || '文件上传失败');
                }
            },
            handleRemove(file, fileList) { // 移除文件
                // 从 approveFileUrls 中移除对应的URL
                let urlToRemove = '';
                if (file.response && file.response.data) {
                    urlToRemove = file.response.data.url;
                } else if (file.url) {
                    urlToRemove = file.url;
                }
                if (urlToRemove && this.form.approveFileUrls) {
                    const urlArray = this.form.approveFileUrls.split(',');
                    const newUrlArray = urlArray.filter(url => url.trim() !== urlToRemove.trim());
                    this.form.approveFileUrls = newUrlArray.join(',');
                }
                this.fileList = fileList;

                // 清除表单验证错误提示
                if (this.$refs.degreeApplyForm) {
                    this.$refs.degreeApplyForm.clearValidate('approveFileUrls');
                }
            },
            beforeUpload(file) { // 上传前校验
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('上传文件大小不能超过 50MB!');
                    return false;
                }
                return true;
            },
            openFillDataDialog() { // 打开填写数据对话框
                this.fillDataDialogVisible = true;
            },
            saveData(){
                this.$refs.childComponent.saveAllData();

                // 清除表单验证错误提示
                if (this.$refs.degreeApplyForm) {
                    this.$refs.degreeApplyForm.clearValidate('attributeRelationList');
                }
            },
            loadDegreeTemplateInfo() { // 加载学位申请模板信息
                // 如果有相关API获取学位申请模板信息，可以在这里调用
                // 示例：获取学位申请相关的模板
                this.$store.dispatch("user/getDegreeApplyTemplate", {}).then((ret) => {
                    if (ret.code === 0 || ret.code === '0') {
                        this.degreeApplyInfo = {
                            templateId: ret.data.templateId || '',
                        };
                        this.getLatestDegreeApplyRecord();
                    } else {
                        this.degreeApplyInfo = {
                            info: '',
                            fileUrls: '',
                            fileUrlList: [],
                            templateId: '',
                            linkTemplateName: ''
                        };
                    }
                }).catch(() => {
                    this.degreeApplyInfo = {
                        info: '',
                        fileUrls: '',
                        fileUrlList: [],
                        templateId: '',
                        linkTemplateName: ''
                    };
                });
            },

            // 获取学位申请配置选项
            degreeApplyForLanguageOption() {
                this.loadingOptions = true;
                this.$store.dispatch("user/degreeApplyForLanguageOption").then(response => {
                    this.loadingOptions = false;
                    if (response.code === 0) {
                        // 如果接口返回的数据结构是数组，直接赋值
                        if (Array.isArray(response.data)) {
                            this.languageOptions = response.data;
                        } else if (response.data && typeof response.data === 'object') {
                            // 如果返回的是配置对象，根据具体结构处理
                            // 假设数据在某个属性中
                            this.languageOptions = response.data.options || [];
                        } else {
                            this.languageOptions = [];
                        }

                        // 如果当前已选择选项，初始化其配置
                        if (this.form.optionKey) {
                            this.updateOptionConfig(this.form.optionKey);
                        }
                    } else {
                        this.$message.error('获取学位申请配置失败: ' + response.msg);
                        this.languageOptions = [];
                    }
                }).catch(error => {
                    this.loadingOptions = false;
                    console.error('获取学位申请配置错误:', error);
                    this.$message.error('获取学位申请配置失败');
                    this.languageOptions = [];
                });
            },

            // 处理外语水平认定选项改变
            handleOptionChange(value) {
                this.updateOptionConfig(value);
            },

            // 更新选项配置
            updateOptionConfig(optionKey) {
                // 在languageOptions中查找对应选项的配置
                const selectedOption = this.languageOptions.find(option => option.key === optionKey);

                if (selectedOption) {
                    // 更新当前选项配置
                    this.currentOptionConfig = {
                        showUserNameInput: selectedOption.showUserNameInput !== undefined ? selectedOption.showUserNameInput : true,
                        showPasswordInput: selectedOption.showPasswordInput !== undefined ? selectedOption.showPasswordInput : true,
                        userNameRequired: selectedOption.userNameRequired !== undefined ? selectedOption.userNameRequired : true,
                        passwordRequired: selectedOption.passwordRequired !== undefined ? selectedOption.passwordRequired : true,
                        showAttachmentInput: selectedOption.showAttachmentInput !== undefined ? selectedOption.showAttachmentInput : true,
                        attachmentRequired: selectedOption.attachmentRequired !== undefined ? selectedOption.attachmentRequired : true
                    };

                    // 动态更新验证规则
                    this.updateValidationRules();
                } else {
                    // 如果没有找到配置，使用默认配置
                    this.currentOptionConfig = {
                        showUserNameInput: true,
                        showPasswordInput: true,
                        userNameRequired: true,
                        passwordRequired: true,
                        showAttachmentInput: true,
                        attachmentRequired: true
                    };

                    // 重置验证规则为默认
                    this.updateValidationRules();
                }
            },

            // 更新验证规则
            updateValidationRules() {
                // 更新用户名验证规则
                if (this.currentOptionConfig.userNameRequired && this.currentOptionConfig.showUserNameInput) {
                    this.rules.userName[0].required = true;
                } else {
                    this.rules.userName[0].required = false;
                }

                // 更新密码验证规则
                if (this.currentOptionConfig.passwordRequired && this.currentOptionConfig.showPasswordInput) {
                    this.rules.password[0].required = true;
                } else {
                    this.rules.password[0].required = false;
                }

                // 触发表单验证以更新UI
                if (this.$refs.degreeApplyForm) {
                    this.$refs.degreeApplyForm.clearValidate();
                }
            },
            // 获取学生最新的申请记录
            getLatestDegreeApplyRecord() {
                this.$store.dispatch("user/getLatestDegreeApplyRecord").then(response => {
                    if (response.code === 0 && response.data) {
                        // 设置表单数据进行反显
                        this.form.optionKey = response.data.optionKey || '';
                        this.form.userName = response.data.userName || '';
                        this.form.password = response.data.password || '';
                        this.form.approveFileUrls = response.data.approveFileUrls || '';
                        this.form.attributeRelationList = response.data.attributeRelationList || [];
                        this.form.degreeApplyRecordId = response.data.degreeApplyRecordId || "";

                        // 获取模板填写的数据
                        const param = {
                            attributeRelationList:this.form.attributeRelationList,
                            templateId:this.degreeApplyInfo.templateId
                        }
                        sessionStorage.setItem(getStorageKeyForRoleTag('template_' + this.degreeApplyInfo.templateId),JSON.stringify(param));

                        // 处理附件列表显示
                        if (response.data.approveFileUrls) {
                            const urls = response.data.approveFileUrls.split(',');
                            this.fileList = urls.map((url, index) => ({
                                name: `附件${index + 1}`,
                                url: url.trim()
                            }));
                        }

                        // 设置审核状态和备注
                        this.auditStatus = response.data.auditStatus;
                        this.auditRemark = response.data.auditRemark;
                        // if(this.auditStatus == 3){
                        //     this.fileList = [];
                        //     this.form.approveFileUrls = "";
                        // }
                        // 显示审核状态和备注
                        if (this.auditStatus) {
                            let statusText = '';
                            switch(this.auditStatus.toString()) {
                                case '1':
                                    statusText = '审核通过';
                                    break;
                                case '2':
                                    statusText = '待审核';
                                    break;
                                case '3':
                                    statusText = '审核不通过';
                                    break;
                                default:
                                    statusText = '未知状态';
                            }
                        }

                        // 如果有历史记录，则进入只读模式，禁止修改与提交
                        this.isReadOnly = true;

                        // 更新选项配置
                        if (this.form.optionKey) {
                            this.updateOptionConfig(this.form.optionKey);
                        }
                    }
                }).catch(error => {
                    console.error('获取最新申请记录失败:', error);
                });
            },

            // 获取审核状态文本
            getAuditStatusText(status) {
                switch(status.toString()) {
                    case '1':
                        return '审核通过';
                    case '2':
                        return '待审核';
                    case '3':
                        return '审核不通过';
                    default:
                        return '未知状态';
                }
            },

            // 获取审核状态样式类
            getStatusClass(status) {
                switch(status.toString()) {
                    case '1':
                        return 'status-passed'; // 审核通过 - 绿色
                    case '2':
                        return 'status-pending'; // 待审核 - 黄色
                    case '3':
                        return 'status-rejected'; // 审核不通过 - 红色
                    default:
                        return 'status-unknown'; // 未知状态
                }
            },


            // 取消申请
            cancelApplication() {
                this.$confirm('确定要取消本次申请吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .page_content {
        background-color: white;
        // padding: 20px;
        border-radius: 5px;
        min-height: calc(100vh - 100px);
    }
    .head_title {
        // text-align: center;
        font-size: 24px;
        margin-bottom: 30px;
    }

    .audit-info {
        margin: 15px 0;
        padding: 15px;
        border-radius: 6px;
        border-left: 4px solid #409EFF;
        background-color: #f8f9fa;

        .audit-status {
            margin-bottom: 8px;
            font-weight: bold;

            &.status-passed {
                color: #67C23A; // 审核通过 - 绿色
                border-color: #67C23A;
                .label {
                    color: #67C23A;
                }
            }

            &.status-pending {
                color: #E6A23C; // 待审核 - 黄色
                border-color: #E6A23C;
                .label {
                    color: #E6A23C;
                }
            }

            &.status-rejected {
                color: #F56C6C; // 审核不通过 - 红色
                border-color: #F56C6C;
                .label {
                    color: #F56C6C;
                }
            }

            &.status-unknown {
                color: #909399; // 未知状态 - 灰色
                border-color: #909399;
                .label {
                    color: #909399;
                }
            }
        }

        .audit-remark {
            .label {
                color: #adadad;
            }
            .value {
                color: #adadad;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/DegreeApplication.vue